import { getInjectedContent } from "@modules/core/services/injected-content";
import { GlobalMetaTagName } from "@modules/core/services/initial-state";

export interface Tag {
  type: 'tag';
  id: number;
  name: string;
  label: string;
  checked?: boolean;
}

export interface TagsMetaReduced {
  [name: string]: Tag;
}

let tagsCache: TagsMetaReduced | null = null;

export const getTags = (): TagsMetaReduced => {
  if (tagsCache) {
    return tagsCache;
  }

  const tagMeta = getInjectedContent<Tag[]>(GlobalMetaTagName.Tags);

  if (!tagMeta) {
    throw new Error('Tags meta tag is missing or invalid');
  }

  tagsCache = tagMeta.reduce((object, value) => Object.assign(object, { [value.name]: value }), {});
  return tagsCache;
};
